import { render, staticRenderFns } from "./PublicRelatedArticleCard.vue?vue&type=template&id=6e997807&lang=pug&"
import script from "./PublicRelatedArticleCard.vue?vue&type=script&lang=js&"
export * from "./PublicRelatedArticleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports